import React from 'react'
import InstagramMural from './InstagramMural'
import FooterMenu from '../components/FooterMenu'
import Copyright from '../components/Copyright'

const Footer = ({ instagram }) =>
  <footer
    css={{
      backgroundColor: '#f6f6f6',
      position: 'relative',

      '@media (min-width: 700px)': {
        marginTop: 120,
      }
    }}
  >
    <InstagramMural images={instagram.edges} />
    <div
      css={{
        margin: '0 auto',
        maxWidth: 600,
      }}
    >
      <FooterMenu />
      <Copyright />
    </div>
  </footer>

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js